/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_MY_ORGANIZATION } from '../graphql';
import { VApplication } from '@/application';
import moment from 'moment-timezone';

import { AppNavigatorService } from '@/AppNavigator';

const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.AppNavigatorService') as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface ICreateBatchSerializationMethods extends IPluginMethodMap {
  createBatchSerialization(args: any): Promise<any>;
}

export class CreateBatchSerializationService implements IAgentPlugin {
  readonly methods: ICreateBatchSerializationMethods;

  constructor() {
    this.methods = {
      createBatchSerialization: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient("graphql-gateway");
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_MY_ORGANIZATION,
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data) {
    //       console.log(`profile data`, res.data);
    //       const _data: any = await this.getFormattedProfile(
    //         res.data?.getMyOrgProfile
    //       );
    //       return {
    //         ...(_data || {}),
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    //let _rowData = this.formatUserTable(tableData);
    return true;
  }

  private formatUserTable(data: any) {
    console.log(`data`, data);
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          data: item,
          id: item?.id,
          // status: item?.status,
          description: item?.description,
          name: item?.name,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          image: item?.icon,
          validFrom: this.formatCreatedDate(item?.validFrom),
          validUntil: this.formatCreatedDate(item?.validUntil),
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    } else {
      return '';
    }
  }
}
